import { DatepickerRange, RangeDatepickerComponent } from '@ui/aos-lib';
import { DateUtil } from '@portal/shared/utils/date-util';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { FieldOperationFilterName } from '../ui/field-operations.types';

const FILTER_WIDTH = 160;

export const REPORT_GROUP = {
  title: TranslateRegistry.get.FILTER.TITLE.REPORT_GROUP,
  items: [],
  filterType: FieldOperationFilterName.ReportGroupUID,
  selected: [],
  isMultiselect: true,
  hasSearch: true,
  width: FILTER_WIDTH
};

export const FIELD_OPERATIONS_DATE_TIME = {
  title: TranslateRegistry.get.FILTER.TITLE.DATE_TIME,
  items: [],
  selected: [],
  filterType: FieldOperationFilterName.InstallationDateTimeUtc,
  isDatepicker: true,
  minDate: null,
  width: 0,
  dateRange: (): string[] => [
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).start),
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).end)
  ],
  defaultDateRange: (): string[] => [
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).start),
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).end)
  ]
};

const INSTALLATION_REASON_ITEMS = [
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.ADD_METER, value: 'AddMeter' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.ADD_MTU, value: 'AddMTU' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.ADD_MTU_ADD_METER, value: 'AddMTUAddMeter' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.READ_MTU, value: 'ReadMTU' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.REPLACE_METER, value: 'ReplaceMeter' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.REPLACE_MTU, value: 'ReplaceMTU' },
  {
    text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.REPLACE_MTU_REPLACE_METER,
    value: 'ReplaceMTUReplaceMeter'
  },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.TURN_OFF_MTU, value: 'TurnOffMTU' },
  { text: TranslateRegistry.get.FILTER.COMMON.UNKNOWN, value: 'Unknown' },
  { text: TranslateRegistry.get.FILTER.INSTALLATION_REASONS.VALVE_POSITION, value: 'ValvePosition' }
];

export const REASON = {
  title: TranslateRegistry.get.FILTER.TITLE.REASON,
  items: INSTALLATION_REASON_ITEMS,
  filterType: FieldOperationFilterName.InstallationReason,
  selected: INSTALLATION_REASON_ITEMS,
  isMultiselect: true,
  width: 184
};

export const WAKE_UP_RECEIVED = {
  title: TranslateRegistry.get.FILTER.TITLE.WAKE_UP_RECEIVED,
  items: [
    { text: 'Yes', value: 'true' },
    { text: 'No', value: 'false' }
  ],
  filterType: FieldOperationFilterName.WakeUpReceived,
  selected: [
    { text: 'Yes', value: 'true' },
    { text: 'No', value: 'false' }
  ],
  isMultiselect: true,
  isNonSortable: true,
  width: FILTER_WIDTH
};

export const READING_RECEIVED = {
  title: TranslateRegistry.get.FILTER.TITLE.READING_RECEIVED,
  items: [
    { text: 'Yes', value: 'true' },
    { text: 'No', value: 'false' }
  ],
  filterType: FieldOperationFilterName.ReadingReceived,
  selected: [
    { text: 'Yes', value: 'true' },
    { text: 'No', value: 'false' }
  ],
  isMultiselect: true,
  isNonSortable: true,
  width: FILTER_WIDTH
};
